const config = {
  contractAddress: "0x382Eec29dD72D117fB7796bf183A3258e0f134EA", // final contract
  nftContractAddress: "0x85B40ff3D24ab9f68FfC46f5DD63A454f4E2A510", // final nft contract
};

export default config;
